import { render, staticRenderFns } from "./render-panorama.vue?vue&type=template&id=654ba858&scoped=true&"
import script from "./render-panorama.vue?vue&type=script&lang=ts&"
export * from "./render-panorama.vue?vue&type=script&lang=ts&"
import style0 from "./render-panorama.vue?vue&type=style&index=0&id=654ba858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ba858",
  null
  
)

export default component.exports